<template>
    <section class="banner-wrap three-column-banner mt-2">
        <div class="container">
            <div class="grid-skeleton" v-if="!isFetchingThreeBanners">
                <BannerGridSkeleton></BannerGridSkeleton>
            </div>
            <div class="row" v-else>
                <div class="col-6 pr-0 pr-md-2">
                    <a
                        :href="data.banner_desktop_1.call_to_action_url"
                        class="banner d-none d-md-block"
                        :target="data.banner_desktop_1.open_in_new_window ? '_blank' : '_self'"
                    >
                        <img :src="data.banner_desktop_1.image.path" alt="banner" width="440" height="140">
                    </a>

                      <a
                        :href="data.banner_mobile_1.call_to_action_url"
                        class="banner d-block d-md-none"
                        :target="data.banner_mobile_1.open_in_new_window ? '_blank' : '_self'"
                    >
                         <img :src="data.banner_mobile_1.image.path" alt="banner" width="440" height="140">
                    </a>
                </div>

                <div class="col-6 px-2 px-md-0">
                      <a
                        :href="data.banner_desktop_2.call_to_action_url"
                        class="banner d-none d-md-block"
                        :target="data.banner_desktop_2.open_in_new_window ? '_blank' : '_self'"
                    >
                        <img :src="data.banner_desktop_2.image.path" alt="banner" width="420" height="140">
                    </a>

                      <a
                        :href="data.banner_mobile_2.call_to_action_url"
                        class="banner d-block d-md-none"
                        :target="data.banner_mobile_2.open_in_new_window ? '_blank' : '_self'"
                    >
                         <img :src="data.banner_mobile_2.image.path" alt="banner" width="420" height="140">
                    </a>
                </div>

                <div class="col-6 pl-0 pl-md-2">
                      <a
                        :href="data.banner_desktop_3.call_to_action_url"
                        class="banner d-none d-md-block"
                        :target="data.banner_desktop_3.open_in_new_window ? '_blank' : '_self'"
                    >
                        <img :src="data.banner_desktop_3.image.path" alt="banner" width="440" height="140">
                    </a>

                      <a
                        :href="data.banner_mobile_3.call_to_action_url"
                        class="banner d-block d-md-none"
                        :target="data.banner_mobile_3.open_in_new_window ? '_blank' : '_self'"
                    >
                         <img :src="data.banner_mobile_3.image.path" alt="banner" width="440" height="140">
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import BannerGridSkeleton from './SkeletonLoader/common/BannerGridSkeleton.vue';

    export default {
        components: { BannerGridSkeleton },
        data() {
            return {
                data: [],
                isFetchingThreeBanners: false,
            };
        },
        created() {
            $.ajax({
                method: 'GET',
                url: route('ecommerce.home.three_column_banners.index'),
            }).then((response) => {
                this.data = response;
                this.isFetchingThreeBanners = true;
            }).catch((xhr) => {
                this.isFetchingThreeBanners = false;
                this.$notify(xhr.responseJSON.message);
            });
        },
    };
</script>
